import * as Yup from "yup";
import { validateDdosFieldValue } from "./matchFieldValidators";
import { FIELD_NONE, OPERATOR_NONE, rowIsComplete, rowIsStarted } from "./matchRowHelpers";
import { runMatchRowFormSchema } from "./yupFormUtils";
import { descriptionField, expiresAtField, nameField } from "./yupCommonFields";

const DDOS_FIELD_NONE = FIELD_NONE;
const DDOS_OPERATOR_NONE = OPERATOR_NONE;

const matchRowSchema = Yup.object({
  field: Yup.string().default(DDOS_FIELD_NONE),
  operator: Yup.string().default(DDOS_OPERATOR_NONE),
  value: Yup.string().default(""),
})
  .test("row-field", function (row) {
    if (!rowIsStarted(row, DDOS_FIELD_NONE, DDOS_OPERATOR_NONE)) return true;
    if (!row.field || row.field === DDOS_FIELD_NONE) {
      return this.createError({ path: `${this.path}.field`, message: "Select a field" });
    }
    return true;
  })
  .test("row-operator", function (row) {
    if (!rowIsStarted(row, DDOS_FIELD_NONE, DDOS_OPERATOR_NONE)) return true;
    if (!row.field || row.field === DDOS_FIELD_NONE) return true;
    if (!row.operator || row.operator === DDOS_OPERATOR_NONE) {
      return this.createError({ path: `${this.path}.operator`, message: "Select an operator" });
    }
    return true;
  })
  .test("row-value", function (row) {
    if (!rowIsStarted(row, DDOS_FIELD_NONE, DDOS_OPERATOR_NONE)) return true;
    if (!row.field || row.field === DDOS_FIELD_NONE) return true;
    if (!row.operator || row.operator === DDOS_OPERATOR_NONE) return true;
    const result = validateDdosFieldValue(row.field, row.value);
    if (!result.valid) {
      return this.createError({ path: `${this.path}.value`, message: result.message });
    }
    return true;
  });

export const ddosExceptionFormSchema = Yup.object({
  name: nameField,
  description: descriptionField,
  expiresAt: expiresAtField,
  matchRows: Yup.array()
    .of(matchRowSchema)
    .test("matchRows-required", function (rows) {
      const list = rows || [];
      const started = list.filter((row) =>
        rowIsStarted(row, DDOS_FIELD_NONE, DDOS_OPERATOR_NONE),
      );
      const fullyValid = list.filter((row) => {
        if (!rowIsComplete(row, DDOS_FIELD_NONE, DDOS_OPERATOR_NONE)) return false;
        return validateDdosFieldValue(row.field, row.value).valid;
      });

      if (fullyValid.length > 0) return true;

      if (started.length === 0) {
        return this.createError({ message: "At least one match criterion is required" });
      }

      const complete = started.filter((row) =>
        rowIsComplete(row, DDOS_FIELD_NONE, DDOS_OPERATOR_NONE),
      );
      if (complete.length === 0) {
        return this.createError({
          message: "Complete at least one match criterion or remove empty rows",
        });
      }

      return true;
    }),
});

export function validateDdosExceptionForm(values) {
  return runMatchRowFormSchema(ddosExceptionFormSchema, values);
}
